<template>
  <div class="mainCard mt-16 mb-16 text-center">
    <v-container class="mb-16">
      <v-row justify="center">
        <v-col cols="auto">
          <div class="text1 sigflo-xl">
            <span
              >Choose Your
              <span class="purpleText">{{ data.name }}</span> System</span
            >
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0">
      <v-row justify="center">
        <v-col
          class="ma-0 pa-0 pb-5 userSystemColumn"
          v-for="(subsystem, index) in data.webSiteSystemModels"
          :key="index"
        >
          <user-system-card
            :userSystem="subsystem"
            :variant="getVariant(index)"
            :index="index"
            idSuffix="userSystems"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import UserSystemCard from '@/components/shared/UserSystemCard.vue';

  export default {
    components: {
      UserSystemCard
    },
    props: {
      data: Object
    },
    methods: {
      /**
       * Returns the variant based on the given index.
       *
       * @param {number} index - The index to determine the variant.
       * @returns {string} The variant corresponding to the index.
       */
      getVariant(index) {
        switch (index % 3) {
          case 0:
            return 'A';
          case 1:
            return 'B';
          case 2:
            return 'C';
        }
      }
    }
  };
</script>

<style scoped>
  .mainCard {
    position: relative;
  }
  .text1 {
    text-align: center;
    flex-shrink: 0;
    width: 757px;
  }
  .imageSquare {
    opacity: 0.8;
  }
  .imageSquare:hover {
    opacity: 1;
  }
  .imageSubtext {
    width: 100%;
    margin-top: 20px;
    color: #2e2f34;
    text-align: center;
  }
  .systemSquare {
    width: 386px;
    cursor: pointer;
  }
</style>
